import React from "react";
import Scrollspy from "react-scrollspy";

export const CalendarJumper = ({ moment, view }) => {
  if (view == "smallMonth" && window.innerWidth > 991) return null;

  const scrollToMonth = (e, month) => {
    e.preventDefault();

    const el = document.getElementById(month);

    window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 180,
      left: 0,
      behavior: "smooth"
    });
  };

  const monthsToJumpTo = [];

  for (let month = 1; month < 13; month++) {
    monthsToJumpTo.push(moment(month, "M").format("MMMM"));
  }

  return (
    <div
      className={`calendarJumper ${
        view === "side" ? "calendarJumper--side" : ""
      } calendarJumper--${view}`}
    >
      <span>Snel naar</span>
      <Scrollspy
        items={monthsToJumpTo}
        currentClassName="is-current"
        offset={-200}
      >
        {monthsToJumpTo.map(month => (
          <li key={month}>
            <a href={`#${month}`} onClick={e => scrollToMonth(e, month)}>
              {month}
            </a>
          </li>
        ))}
      </Scrollspy>
    </div>
  );
};
